
export const savedItemsData = {
  products: [
    {
      id: 'sp1',
      name: '스테인리스 와이어 로프',
      category: '어구류',
      manufacturer: '부산해양산업',
      description: '316 스테인리스강 재질의 고강도 와이어 로프. 내식성이 우수하며 해양 환경에 최적화되어 있습니다.',
      price: '₩85,000/100m',
      image: 'https://public.readdy.ai/ai/img_res/31bc9717f618ff09c677e9c17da24fe3.jpg'
    },
    {
      id: 'sp2',
      name: '대형 스테인리스 샤클',
      category: '갑판용품',
      manufacturer: '여수해양공업',
      description: '316 스테인리스강 재질의 대형 샤클. 5톤 하중을 견딜 수 있으며 ISO 9001 인증을 받았습니다.',
      price: '₩45,000/개',
      image: 'https://readdy.ai/api/search-image?query=heavy-duty-stainless-steel-shackle-with-screw-pin-showing-polished-metallic-surface-and-robust-construction-on-clean-white-background-professional-marine-hardware-product-photography&width=300&height=300&seq=sp2&orientation=squarish'
    },
    {
      id: 'sp3',
      name: '고성능 어망 블록',
      category: '어구류',
      manufacturer: '목포수산기자재',
      description: '내구성이 뛰어난 폴리머 재질의 어망 블록. 부식에 강하고 장기간 사용 가능합니다.',
      price: '₩32,000/개',
      image: 'https://readdy.ai/api/search-image?query=high-performance-marine-fishing-block-pulley-with-polymer-construction-and-stainless-steel-sheave-on-white-background-showing-durable-design-for-commercial-fishing-vessels-professional-equipment-photography&width=300&height=300&seq=sp3&orientation=squarish'
    },
    {
      id: 'sp4',
      name: '선박용 유압펌프',
      category: '기관물품',
      manufacturer: '통영기계공업',
      description: '고효율 선박용 유압펌프. 저소음 설계로 안정적인 작동이 가능하며 유지보수가 간편합니다.',
      price: '₩1,250,000/대',
      image: 'https://readdy.ai/api/search-image?query=industrial-marine-hydraulic-pump-with-metallic-housing-and-precision-engineering-on-clean-white-surface-showing-professional-grade-construction-for-commercial-vessels-technical-equipment-product-shot&width=300&height=300&seq=sp4&orientation=squarish'
    }
  ],
  manufacturers: [
    {
      id: 'sm1',
      name: '부산해양산업',
      location: '부산광역시',
      category: '어구류 전문',
      rating: 4.8,
      reviews: 127,
      description: '30년 전통의 어구 전문 제조업체. 와이어 로프, 그물, 로프 등 다양한 어구를 생산합니다.',
      specialties: ['와이어 로프', '어망', '로프'],
      logo: 'https://readdy.ai/api/search-image?query=modern-maritime-industry-company-logo-design-with-anchor-and-wave-elements-in-teal-blue-colors-on-white-background-professional-corporate-branding-for-fishing-equipment-manufacturer&width=200&height=200&seq=sm1&orientation=squarish'
    },
    {
      id: 'sm2',
      name: '여수해양공업',
      location: '전라남도 여수시',
      category: '갑판용품 전문',
      rating: 4.9,
      reviews: 98,
      description: 'ISO 9001 인증 갑판용품 전문 제조업체. 샤클, 체인, 앵커 등을 생산합니다.',
      specialties: ['샤클', '체인', '앵커'],
      logo: 'https://readdy.ai/api/search-image?query=professional-marine-engineering-company-logo-with-ship-propeller-and-gear-design-in-navy-blue-and-silver-on-white-background-industrial-corporate-identity-for-deck-equipment-manufacturer&width=200&height=200&seq=sm2&orientation=squarish'
    },
    {
      id: 'sm3',
      name: '통영기계공업',
      location: '경상남도 통영시',
      category: '기관물품 전문',
      rating: 4.7,
      reviews: 156,
      description: '선박 기관 부품 전문 제조업체. 펌프, 밸브, 필터 등 각종 기관 부품을 공급합니다.',
      specialties: ['유압펌프', '밸브', '필터'],
      logo: 'https://readdy.ai/api/search-image?query=technical-machinery-company-logo-featuring-mechanical-gears-and-engine-elements-in-dark-gray-and-orange-colors-on-white-background-industrial-branding-for-marine-engine-parts-manufacturer&width=200&height=200&seq=sm3&orientation=squarish'
    },
    {
      id: 'sm4',
      name: '보령해양기자재',
      location: '충청남도 보령시',
      category: '어구류 전문',
      rating: 4.6,
      reviews: 84,
      description: '서해안 최대 어구 제조업체. 다양한 어종에 맞는 맞춤형 어구를 제작합니다.',
      specialties: ['트롤 어구', '자망', '통발'],
      logo: 'https://readdy.ai/api/search-image?query=coastal-fishing-equipment-company-logo-with-net-and-fish-silhouette-design-in-ocean-blue-and-white-colors-on-clean-background-maritime-corporate-branding-for-fishing-gear-supplier&width=200&height=200&seq=sm4&orientation=squarish'
    }
  ]
};
